<!--
 * @Description: 
 * @Author: pliybird
 * @Date: 2023-07-11 14:13:51
 * @LastEditTime: 2023-07-11 15:21:39
 * @LastEditors: pliybird
 * @filePath: Do not edit
-->
<template>
  <div class="new-medicine-advantages">
    <section class="advantages rn-section-gap">
      <div class="container advantage-content">
        <SectionTitle
          :title="$t('solution.advantages_title')"
          description="ADVANTAGES"
          textAlign="center"
        />
        <div>
          <div
            class="advantage-content_01 row col-lg-9 col-md-8 col-sm-12 col-12 offset-md-1 p-4 gx-5"
          >
            <div class="content-icon icon_left">
              <img
                src="@/assets/images/IndustrySolution/MedicineAdvantages/Advantages-icon01.png"
                alt=""
              />
            </div>
            <div class="content">
              {{ $t("solution.medicine.advantages.description01") }}
            </div>
          </div>
          <div
            class="advantage-content_01 row col-lg-9 col-md-8 col-sm-12 col-12 offset-md-2 p-4 gx-5"
          >
            <div class="content-icon icon_right">
              <img
                src="@/assets/images/IndustrySolution/MedicineAdvantages/Advantages-icon02.png"
                alt=""
              />
            </div>
            <div class="content">
              {{ $t("solution.medicine.advantages.description02") }}
            </div>
          </div>
          <div
            class="advantage-content_01 row col-lg-9 col-md-8 col-sm-12 col-12 offset-md-1 p-4 gx-5"
          >
            <div class="content-icon icon_left">
              <img
                src="@/assets/images/IndustrySolution/MedicineAdvantages/Advantages-icon03.png"
                alt=""
              />
            </div>
            <div class="content">
              {{ $t("solution.medicine.advantages.description03") }}
            </div>
          </div>
          <div
            class="advantage-content_01 row col-lg-9 col-md-8 col-sm-12 col-12 offset-md-2 p-4 gx-5"
          >
            <div class="content-icon icon_right">
              <img
                src="@/assets/images/IndustrySolution/MedicineAdvantages/Advantages-icon04.png"
                alt=""
              />
            </div>
            <div class="content">
              {{ $t("solution.medicine.advantages.description04") }}
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import SectionTitle from '../../../components/elements/sectionTitle/SectionTitle.vue'

export default {
  name: 'MedicineAdvantage',
  components: {
    SectionTitle
  },
  props: {
    // 'medicineAdvantagesData':{
    //   type:Array,
    //   default: [],
    // },
  },
  computed: {

  },
  data () {
    return {
      data: [],
    }
  },
  methods: {

  }
}
</script>